export enum AllowedEXNavRoutes {
  Insured = '/ex-ucm-forms/ex-insured',
  Owner = '/ex-ucm-forms/ex-owner',
  Ratings = '/ex-ucm-forms/ex-ratings',
  Excess = '/ex-ucm-forms/ex-liability',
  Automobile = '/ex-ucm-forms/ex-automobile',
  Employeebenefits = '/ex-ucm-forms/ex-employeebenefits',
  Employersliability = '/ex-ucm-forms/ex-employersliability',
  GeneralQuestion = '/ex-ucm-forms/ex-generalquestion',
  CoverageQuestion = '/ex-ucm-forms/ex-coveragequestion',
  Document = '/excess/underwriting/documents',
  RenewalReview = '/ex-ucm-forms/ex-renewalreview',
  Snapshot = '/excess/pending-review/policysnapshot',
  EXCoverage = '/excess/pending-review/verifycoverage',
  EXPolicy = '/excess/pending-review/verifypolicy',
  VPActionItems = '/excess/verify-purchase/actionitems',
  VPCoverage = '/excess/verify-purchase/coverages',
  VPPolicy = '/excess/verify-purchase/policy'
}

export enum AllowedEXBoundNavRoutes {
  PolicyInfo = '/bound',
  Coverage = '/bound',
  Snapshot = '/bound',
  Declined = '/declined'
}

export enum EXSubmissionRoutes {
  Step1A = AllowedEXNavRoutes.Insured,
  Step1Address = AllowedEXNavRoutes.Insured,
  Step1AUpdate = AllowedEXNavRoutes.Insured,
  // Step1B = AllowedEXNavRoutes.Owner,
  // Step1BUpdate = AllowedEXNavRoutes.Owner,
  // Step1C = AllowedEXNavRoutes.Ratings,
  // Step1CUpdate = AllowedEXNavRoutes.Ratings,
  Step1B = AllowedEXNavRoutes.Ratings,
  Step1BUpdate = AllowedEXNavRoutes.Ratings,
  Step2A = AllowedEXNavRoutes.Excess,
  Step2AUpdate = AllowedEXNavRoutes.Excess,
  Step2B = AllowedEXNavRoutes.Automobile,
  Step2BUpdate = AllowedEXNavRoutes.Automobile,
  Step2C = AllowedEXNavRoutes.Employeebenefits,
  Step2CUpdate = AllowedEXNavRoutes.Employeebenefits,
  Step2D = AllowedEXNavRoutes.Employersliability,
  Step2DUpdate = AllowedEXNavRoutes.Employersliability,
  Step3A = AllowedEXNavRoutes.GeneralQuestion,
  Step3AUpdate = AllowedEXNavRoutes.GeneralQuestion,
  Step3B = AllowedEXNavRoutes.CoverageQuestion,
  Step3BUpdate = AllowedEXNavRoutes.CoverageQuestion,
  Step3C = AllowedEXNavRoutes.Document,
  Step3CUpdate = AllowedEXNavRoutes.Document,
  Renewal = AllowedEXNavRoutes.RenewalReview,
  RenewalReview = AllowedEXNavRoutes.RenewalReview,
  Step4A = AllowedEXNavRoutes.VPActionItems,
  Step4CompForms = AllowedEXNavRoutes.VPActionItems,
  Step4DwnloadDoc = AllowedEXNavRoutes.VPActionItems,
  Step4InstBill = AllowedEXNavRoutes.VPActionItems,
  Step4InstPaid = AllowedEXNavRoutes.VPActionItems,
  Step4InsurForm = AllowedEXNavRoutes.VPActionItems,
  Step4NewTxn = AllowedEXNavRoutes.VPActionItems,
  Step4BRemFin = AllowedEXNavRoutes.VPActionItems,
  Step4Purchase = AllowedEXNavRoutes.VPActionItems,
  Step4Update = AllowedEXNavRoutes.VPActionItems,
  EHelpUWReview = AllowedEXNavRoutes.Snapshot,

  Declined = AllowedEXBoundNavRoutes.Declined,
  'Declined New Business' = AllowedEXBoundNavRoutes.Declined,
  EHelBReviewDoc = AllowedEXBoundNavRoutes.Snapshot,
  InspCreated = AllowedEXBoundNavRoutes.Snapshot,
  InspInfoRequest = AllowedEXBoundNavRoutes.Snapshot,
  InsBReview = AllowedEXBoundNavRoutes.Snapshot,
  PolicyBound = AllowedEXBoundNavRoutes.Snapshot,
  StepENAddChange = AllowedEXBoundNavRoutes.Snapshot,
  StepENAIChange = AllowedEXBoundNavRoutes.Snapshot,
  StepENExpChange = AllowedEXBoundNavRoutes.Snapshot,
  InspCompleted = AllowedEXBoundNavRoutes.Snapshot
}
